<template>
  <div :class="{'main-header': $route.name === 'memorial.show'}" class="profile-header">
    <template v-if="entity">
      <b-button
        v-if="$root.canManage() && $route.name === 'memorial.show'"
        size="sm"
        class="edit-style"
        @click="openModal(modalName('memorial_style'))"
      >
        <i class="ti ti-fw ti-2x ti-cog" />
      </b-button>
      <div
        :style="`background-image:url(${entity.background ? imgurl(entity.background.file_url, 'full') : defaultCover})`"
        class="cover-img"
      />
      <profile-picture :item="entity" />
      <div class="info">
        <h2>{{ entity.first_name }} {{ entity.last_name }}</h2>
        <small>
          {{ entity.birth_date | moment('LL') }} - <span>{{ entity.death_date | moment('LL') }}</span>
        </small>
        <p v-if="entity.age && entity.age > 1" class="m-0">{{ entity.age }} {{ $t('pages.memorial.years') }}</p>
        <p v-else-if="entity.age" class="m-0">{{ entity.age }} {{ $t('pages.memorial.year') }}</p>
      </div>
    </template>
    <template v-else>
      <i class="ti ti-refresh ti-spin" />
    </template>
    <e-modal
      v-if="user()"
      :event-id="modalName('memorial_style')"
      :title="$t('pages.memorial.style')"
    >
      <ajax-edit
        :name="name"
        :uri="uri"
        :id="id"
        :additionnal-route="additionnal_route"
        :close-modal="true"
        :load-on-mount="false"
        :ref-modal="modalName('memorial_style')"
      />
    </e-modal>
  </div>
</template>

<script>
  import ProfilePicture from '@/components/ProfilePicture';
  import AjaxEdit from '@triotech/vue-core/src/components/ajax/AjaxEdit';
  import EModal from '@/components/EModal';

  export default {
    name: 'ProfileModuleComponent',
    components: {
      ProfilePicture,
      AjaxEdit,
      EModal,
    },
    data() {
      return {
        entity: null,
        name: 'memorial',
        uri: 'api/memorial',
        additionnal_route: 'style',
        id: null,
        // eslint-disable-next-line no-underscore-dangle
        uid: this._uid,
      };
    },
    computed: {
      defaultCover: () => '../../static/img/default_cover.jpg',
    },
    mounted() {
      this.$bus.$on('t-event.get-memo.success', (memo) => {
        this.entity = memo;
      });

      if (this.get().memorial) {
        this.entity = this.get().memorial;
      }
      if (this.user() && this.user().memorial) {
        this.id = this.user().memorial.id;
      }
    },
    methods: {
      modalName(action) {
        return `${action}-${this.uid}`;
      },
      openModal(id, data = null) {
        this.$bus.$emit(`t-event.t-modal.${id}.open`, data);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';
  @import 'compass/css3';

  .profile-header {
    position: relative;
    min-height: 200px;
    margin-bottom: 10px;

    /deep/ .profile-pic-container {
      position: fixed;
      top: 175px;
      left: 35px;
      z-index: 2;

      .profile-pic {
        margin-bottom: 20px;
        @include transform(rotate(-10deg));
      }
    }

    /deep/ .edit-style {
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .cover-img {
      width: 100%;
      height: 200px;
      background: {
        size: cover;
        position: center;
      }
    }

    .info {
      bottom: 30px;
      left: 30px;

      h2 {
        display: inline-block;
        margin: 10px 20px 10px 0;
        font-size: 2rem !important;
      }

      small {
        font-size: 90%;
      }
    }
  }

  @include editable-max-width(1660px) {
    .profile-header {
      /deep/ .profile-pic-container {
        .profile-pic {
          width: 150px;
          height: 150px;
        }

        a {
          max-width: 160px;
        }
      }
    }
  }

  @include editable-max-width(1520px) {
    .profile-header {
      /deep/ .profile-pic-container {
        position: absolute;
        top: 30px;

        a {
          max-width: none;
          background-color: $primary;
          padding: 5px 10px;
          color: $white;
          border-radius: 5px;

          @include transition(background-color .3s);

          &:hover {
            background-color: darken($primary, 10);
          }
        }
      }

      &:not(.main-header) {
        /deep/ .profile-pic-container {
          position: absolute;
          top: 15px;
          left: auto;
          right: 30px;
          text-align: right;

          .profile-pic {
            display: inline-block;
            width: 120px;
            height: 120px;
            margin-bottom: 10px;

            @include transform(none);
          }

          a {
            max-width: none;
          }
        }
      }
    }
  }

  @include editable-max-width(765px) {
    .profile-header {
      /deep/ .edit-style {
        position: absolute;
        right: 10px;
        top: 10px;
      }

      .cover-img {
        margin-bottom: 30px;
      }

      /deep/ .profile-pic-container {
        left: 33%;
        top: auto;
        bottom: 50px;

        .profile-pic {
          width: 100px;
          height: 100px;
          display: inline-block;
        }

        a {
          display: inline-block;
          vertical-align: top;
          max-width: 160px;
          margin-left: 10px;
        }
      }

      .info {
        bottom: 10px;

        h2 {
          display: block;
          font-size: 2rem !important;
        }
      }

      &:not(.main-header) {
        /deep/ .profile-pic-container {
          top: 10px;
          left: 10px;
          right: 10px;
          text-align: left;

          .profile-pic {
            width: 50px;
            height: 50px;
            display: inline-block;
          }

          a {
            max-width: none;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProfileModule.vue